import jwtDecode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import refreshToken from '../utils/refreshToken';
import axios from '../utils/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    //@ts-ignore
    const dispatch = useDispatch();

    const refresh = async () => {
        const newAccessToken = await refreshToken(dispatch);
        return newAccessToken;
    };

    return refresh;
    // const refresh = async () => {
    //     const response = await axios.get(`/sessions/refresh`, {
    //         withCredentials: true
    //     });
    //     // console.log('response', response);
    //     setAuth((prev: any) => {
    //         // console.log(JSON.stringify(prev))
    //         // console.log(response.data);
    //         let userData = jwtDecode(response.data);
    //         return {
    //             ...prev,
    //             //@ts-ignore
    //             roles: [userData?.roleId ? userData.roleId : 2001],
    //             user: userData ? userData : {},
    //             accessToken: response.data
    //         }
    //     })
    //     return response.data.accessToken;
    // }
    // return refresh;
}

export default useRefreshToken;